export default "__VITE_ASSET__Bvw9G99y__"